import { dataLoader } from '../../web/utilities/dataLoader';

export function initialise(dispatch) {
  const optimizelyDataObject = dataLoader('optimizely-data');

  // need to do the following to fix the jest test
  // during jest test, somehow optimizelyDataObject would return {} which is
  // a wrong type; the feature is supposed to be an array
  const fixedOptimizelyDataObject =
    optimizelyDataObject instanceof Array ? optimizelyDataObject : [];

  return dispatch({
    type: 'READ_OPTIMIZELY_FEATURES_FROM_DOM',
    features: fixedOptimizelyDataObject,
  });
}
